import React, { useState } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IoAdd, IoClose } from "react-icons/io5";
import styled from "styled-components";

import * as userActions from "../../actions/userActions";
import * as loaderActions from "../../actions/loaderActions";

const TagInput = ({
  values,
  onChange,
  name,
  getValue,
  setValue,
  errorMsg,
  isError,
  placeholder = "User",
  disabled,
  label,
  maxWidth
}) => {
  const [text, setText] = useState("");

  const handleChange = (v) => {
    setText(v);
  };

  const handleAddItem = () => {
    onChange(name, setValue([...values, text]), text);
    setText("");
  };

  const handleRemoveItem = (val) => {
    const newItems = values.filter((v) => v !== val);
    onChange(name, setValue(newItems));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAddItem();
    }
  };

  return (
    <div style={{ maxWidth }}>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}

      <StyledTagOuterContainer>
        <StyledInnerContainer1>
          <StyledInnerContainer2>
            {values &&
              getValue(values).map((val) => (
                <StyledTagContainer key={val}>
                  <span>{val}</span>

                  <StyledRemoveButton onClick={() => handleRemoveItem(val)}>
                    <IoClose size={12} style={{ marginTop: "0.5rem" }} />
                  </StyledRemoveButton>
                </StyledTagContainer>
              ))}
            <StyledInput
              name={name}
              value={text}
              placeholder={placeholder}
              disabled={disabled}
              onChange={(e) => handleChange(e?.target?.value)}
              onKeyDown={handleKeyDown}
            />
          </StyledInnerContainer2>

          <StyledDivider />

          <StyledAddButton onClick={() => handleAddItem()}>
            <IoAdd size={20} style={{ marginTop: "0.5rem" }} />
          </StyledAddButton>
        </StyledInnerContainer1>
      </StyledTagOuterContainer>
      <StyledErrorContainer>
        {isError && <StyledErrorText>{errorMsg}</StyledErrorText>}
      </StyledErrorContainer>
    </div>
  );
};

const StyledTagOuterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  overflow: hidden;
  border: ${(props) =>
    props.theme.nightmode
      ? `1px solid ${props.theme.dark_input}`
      : `1px solid ${props.theme.light_grey}`};
  border-radius: 0.5rem;
`;

const StyledInnerContainer1 = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: "0.5rem";
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_navy : "#fff"};
`;

const StyledInnerContainer2 = styled.div`
  width: 95%;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 0.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  flex-wrap: wrap;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_navy : "#fff"};
`;

const StyledTagContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  border-radius: 1rem;
  margin-left: 1rem;
  white-space: nowrap;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_input : `rgba(80, 172, 203, 0.2)`};
`;

const StyledInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: start;
  min-width: 20rem;
  flex: 1;
  border-radius: 0.5rem;
  color: white;
  border: none;
  height: 5rem;
  margin-left: 1rem;
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_navy : "#fff"};
  color: ${(props) =>
    props.theme.nightmode ? "#fff" : props.theme.dark_grey} !important;
`;

const StyledAddButton = styled.button`
  min-height: 5rem;
  width: 3rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  border: none;
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_navy : "#fff"};
  color: ${(props) => (props.theme.nightmode ? "#fff" : props.theme.dark_grey)};
`;

const StyledRemoveButton = styled.button`
  border-radius: 50%;
  border: none;
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_input : `rgba(80, 172, 203, 0.2)`};
`;

const StyledErrorText = styled.text`
  color: ${(props) => props.theme.red_g};
  font-size: 12.5px;
`;

const StyledDivider = styled.div`
  height: 3rem;
  background-color: #50accb;
  border-radius: 1rem;
  width: 0.2rem;
  margin-left: auto;
`;

const StyledErrorContainer = styled.div`
  margin-top: 0.25rem;
`;

TagInput.propTypes = {
  isError: PropTypes.bool,
  values: PropTypes.array,
  name: PropTypes.string,
  errorMsg: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  maxWidth: PropTypes.string
};

TagInput.defaultProps = {
  values: [],
  disabled: false,
  errorMsg: "Tag must have at least 1 character and no special characters.",
  onChange: () => {},
  setValue: (x) => x,
  getValue: (x) => x
};

function mapStatesToProps(state) {
  return {
    users: state.reducers.users,
    loading: state.reducers.loading
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...loaderActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(TagInput);
